import { Button, Grid, Paper } from '@mui/material';
import { withStyles } from 'utils/styles';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import Fingerprint from '@mui/icons-material/Fingerprint';
import Alert from 'components/Alert';
import { cleanAlert } from 'ducks/alerts';
//import { login } from 'ducks/auth';
import reachOKLogo from 'images/brand/REACHok_branco.png';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import theme from 'source/theme';
import styles from './styles';

const Component = props => {
  const { classes, alert } = props;
  const { cleanAlert } = props;
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');

  const handleChangePassword = event => {
    setPassword(event.target.value);
  };

  const handleChangeVerifyPassword = event => {
    setVerifyPassword(event.target.value);
  };

  const handleSubmit = () => {
    //props.passwordRecovery(password);
  };

  return (
    <div className={classes.container}>
      <div className={classes.loginArea}>
        <Paper className={classes.paper}>
          <div className={classes.margin}>
            <Alert
              open={alert.message.length !== 0}
              message={alert.message}
              handleClose={cleanAlert}
              placement={{ vertical: 'top', horizontal: 'right' }}
              variant={'error'}
            />

            <Grid sx={{ justifyContent: 'center' }} container>
              <Grid size={8}>
                <img src={reachOKLogo} style={{ width: '100%' }} alt=""/>
              </Grid>
            </Grid>

            <Divider style={{ marginBottom: '15px' }}/>

            <Grid sx={{ justifyContent: 'center' }} container spacing={8}>
              <Grid size={10}>
                <Typography
                  variant="h6" align='center' gutterBottom
                  style={{ color: theme.palette.secondary.dark }}
                >
                  Password Recovery!
                </Typography>
                <Typography
                  color='textSecondary' variant="body2" align='justify' gutterBottom
                  style={{ color: theme.palette.secondary.dark }}
                >
                  Please insert your new password, to recover your account.
                  Thank you!
                </Typography>
              </Grid>
            </Grid>

            <Divider style={{ marginTop: '15px', marginBottom: '30px' }}/>

            <ValidatorForm onSubmit={handleSubmit}>
              <Grid container className={classes.textInput}>
                <Grid size="grow">
                  <TextValidator
                    // `variant` explicitly, because the theme's default
                    // does not reach here: the validator does
                    // `require('@mui/material/TextField')` - CommonJS - while
                    // the application imports the ESM build, and rspack bundles
                    // both. Each copy has its own defaults context, so the
                    // ThemeProvider fills one and this TextField reads the
                    // other, empty, and falls back to v5's `outlined`. v4's
                    // default was `standard`, an underline, which is what the
                    // login screen has always looked like.
                    variant="standard"
                    slotProps={{ input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Fingerprint className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    } }}
                    label="Password"
                    onChange={handleChangePassword}
                    name="password"
                    value={password}
                    validators={['required']}
                    errorMessages={['this field is required']}
                    fullWidth
                    type='password'
                  />
                </Grid>
              </Grid>
              <Grid container className={classes.textInput}>
                <Grid size="grow">
                  <TextValidator
                    variant="standard"
                    slotProps={{ input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Fingerprint className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    } }}
                    label="Verify Password"
                    onChange={handleChangeVerifyPassword}
                    name="verifypassword"
                    value={verifyPassword}
                    validators={['required']}
                    errorMessages={['this field is required']}
                    fullWidth
                    type='password'
                  />
                </Grid>
              </Grid>

              <Grid sx={{ justifyContent: 'center' }} container style={{ marginTop: '30px' }}>
                <Button
                  type="submit"
                  className={classes.textTransformationNone}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </Grid>
            </ValidatorForm>

          </div>
        </Paper>
      </div>
    </div>
  );
};

Component.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  alert: state.alert
});

const mapDispatchToProps = dispatch => ({
  // passwordRecovery(password) {
  //   dispatch(passwordRecovery(password));
  // },
  cleanAlert() {
    dispatch(cleanAlert());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Component));
